exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.vue-map-container .vue-map {\n   border-radius: 10px;\n}\n", ""]);

